module.exports = __webpack_public_path__ + "static/media/products.6578baba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/products.jpg
// module id = 100
// module chunks = 0